import { render } from "./RoleEditData.vue?vue&type=template&id=4d568272"
import script from "./RoleEditData.vue?vue&type=script&lang=js"
export * from "./RoleEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__